import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { formatNumber } from '../utils/csvParser';

interface KPICardProps {
  title: string;
  value: string | number | ReactNode;
  subtitle?: string | ReactNode;
  icon: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

export default function KPICard({ title, value, subtitle, icon: Icon, trend }: KPICardProps) {
  return (
    <div className="bg-card rounded-lg shadow-sm p-3 border border-border aspect-square">
      <div className="flex items-start justify-between h-full">
        <div className="flex-1">
          <p className="text-xl font-medium text-muted-foreground">{title}</p>
          {typeof value === 'string' || typeof value === 'number' ? (
            <p className="text-xl font-semibold text-white mt-1">{value}</p>
          ) : (
            <div className="mt-0.5">{value}</div>
          )}
          {subtitle && <p className="text-iss text-muted-foreground mt-1">{subtitle}</p>}
          {trend && (
            <div className="flex items-center mt-0.5">
              <span
                className={`text-xs font-medium inline-block ${
                  trend.isPositive
                    ? 'text-success'
                    : 'text-destructive'
                }`}
              >
                {trend.isPositive ? '↑' : '↓'} {formatNumber(Math.abs(trend.value), 2)}%
              </span>
            </div>
          )}
        </div>
        <div className="ml-1.5 flex-shrink-0">
          <Icon className="w-7.5 h-7.5 text-muted-foreground" />
        </div>
      </div>
    </div>
  );
}
